import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorCustomerAccountSearch = () => {
  const customerAccountSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/customer/account/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { customerAccountSearch }
}

export default InteractorCustomerAccountSearch
